import http from "../../http";

const agent = {
    // 代理商列表分页
    selectAgentPage(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyAgentPC/selectAgentPage", r)
    },
    // 查询代理商详情
    selectAgentById(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyAgentPC/selectAgentById", r)
    },
    // 新增/修改代理商
    saveAgent(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/CompanyAgentPC/saveAgent", r)
    },
    // 删除代理商
    deleteAgent(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/CompanyAgentPC/deleteAgent", r)
    },
    // 查询代理商绑定的下属机构
    getAgentHasBranchList(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyAgentPC/getAgentHasBranchList", r)
    },
    // 保存代理商绑定的下属机构
    saveAgentBranch(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/CompanyAgentPC/saveAgentBranch", r)
    },
    // 删除代理商的下属机构
    deleteAgentBranch(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/CompanyAgentPC/deleteAgentBranch", r)
    },
    // 分页查询成员列表
    selectAgentUserPage(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyAgentPC/selectAgentUserPage", r)
    },
    // 查询成员
    selectAgentUserById(r) {
        return http.get("/gateway/api/sycompany/pc/CompanyAgentPC/selectAgentUserById", r)
    },
    // 新增/修改成员
    saveAgentUser(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/CompanyAgentPC/saveAgentUser", r)
    },
    // 删除成员
    deleteAgentUser(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/CompanyAgentPC/deleteAgentUser", r)
    },
    queryBillData(r) {
        return http.spin.get("/gateway/api/sycompany/pc/OrderCenterBillPC/queryBillData", r)
    },
}
export default agent
